export default __webpack_public_path__ + "static/media/bg-img-getting-started@2x.3f97b09d.jpg";